import React, { Component } from "react"
import { Button, Segment } from "semantic-ui-react"
import "./Offre.css"

class Offre extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <Segment id="blockOffre">
        <h1 id="titleCompteTarif">L'offre la plus complete du marché</h1>
        <Segment.Group horizontal id="cardsBlock">
          <Segment id="cardMensuel">
            Mensuel{" "}
            <Segment id="tarifMensuel">
              <p id="prixTarif">20</p>
              <p id="parMois">€ / mois HT</p>
            </Segment>
            <p id="essai">Un mois d'essai gratuit !</p>
            <Button id="btnCompte">Je crée mon compte</Button>
          </Segment>
          <Segment id="cardAnnuel">
            Annuel{" "}
            <Segment id="tarifAnnuel">
              <p id="prixTarif">15</p>
              <p id="parMois">€ / mois HT</p>
            </Segment>
            <p id="essai">à payer pour 12 mois, soit 228€ pour 1 ans</p>
            <Button id="btnCompte">Je crée mon compte</Button>
          </Segment>
        </Segment.Group>
        <hr id="hrOffre" />
        <h1 id="titleCompteTarif">
          En plus gérez vos stock avec MonStock + MyTravo Pro
        </h1>
        <Segment.Group horizontal id="cardsBlock">
          <Segment id="cardMensuelMS">
            Mensuel{" "}
            <Segment id="tarifMensuelMS">
              <p id="prixTarifMS">35</p>
              <p id="parMoisMS">€ / mois HT</p>
            </Segment>
            <p id="essaiMS">Un mois d'essai gratuit !</p>
            <Button id="btnCompteMS">Je crée mon compte</Button>
          </Segment>
          <Segment id="cardAnnuelMS">
            Annuel{" "}
            <Segment id="tarifAnnuelMS">
              <p id="prixTarifMS">28</p>
              <p id="parMoisMS">€ / mois HT</p>
            </Segment>
            <p id="essaiMS">à payer pour 12 mois, soit 228€ pour 1 ans</p>
            <Button id="btnCompteMS">Je crée mon compte</Button>
          </Segment>
        </Segment.Group>
      </Segment>
    )
  }
}

export default Offre


// WEBPACK FOOTER //
// ./src/components/Pro/AcceuilLandingPage/Offre.js